import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { LeadsComp } from './leads';
import { GetLeadsFromStorage, GetProcessList } from '../../models/process';
import { pnkstore } from '../../stores/pnk-store';
import { useUserStore } from '../../stores/user-store';
import { useNavigate } from 'react-router-dom';
import { GetAllLeads, AddInteraction, MakeCall } from '../../models/leads';
import { Filters } from '../Filters';
import { GetUserList } from '../../models/user';

export const Leads = () => {
    const userData = useUserStore;
    const [openFilter, setOpenFilter] = useState(false);
    const [getLeadList, setGetLeadList] = useState(false);
    const [leadList, setLeadList] = useState([]);

    const [leadObj, setLeadObj] = useState({});
    const [setNo, setSetNo] = useState(1);
    const [perSet, setPerSet] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);

    const [interactionData, setInteractionData] = useState({});

    const [callObj, setCallObj] = useState({});
    const [makeCall, setMakeCall] = useState(false);

    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertMsg, setAlertMsg] = useState('');

    const [openInteractionBox, setOpenInteractionBox] = useState(false);

    const [statusListArray, setstatusListArray] = useState([]);
    const [getUserList, setGetUserList] = useState(false);
    const [userListData, setUserListData] = useState([]);

    const [addInteraction, setAddInteraction] = useState(false);

    const navigate = useNavigate();


    const state = {
        userData: userData.getState(),
        getLeadList: getLeadList,
        leadList: leadList,
        totalRecords: totalRecords,
        perSet: perSet,
        setNo: setNo,
        leadObj: leadObj,
        showAlert: showAlert,
        alertMsg: alertMsg,
        alertType: alertType,
        openInteractionBox: openInteractionBox,
        statusListArray: statusListArray,
        userListData: userListData
    }



    useEffect(() => {
        let statusListArray = ['Pending', 'RNR', 'Hold', 'Call Back', 'Dead', 'In Progress'];
        setstatusListArray(statusListArray);
        setLeadObj({
            'set_no': setNo,
            'per_set': perSet,
            'ddlCandidateStatus': userData.getState().profile === 'Admin' || userData.getState().profile === 'Marketing' ? 'Not Shortlisted' : userData.getState().profile.includes('Sales') ? 'Shortlisted' : ''
        })
        setGetLeadList(true);
    }, []);

    const HandleChangePage = (event, page) => {
        let set_no = setNo;
        if (event.currentTarget.title == 'Go to next page') {
            set_no = set_no + 1;
        }
        else {
            set_no = set_no - 1;
        }
        setSetNo(set_no);
        setLeadObj((prev) => ({ ...prev, ['set_no']: set_no }));
        setGetLeadList(true);
    };

    const HandleCloseAlertMsg = (type) => {
        setTimeout(() => {
            setShowAlert(false);
            setAlertType('');
            setAlertMsg('');
        }, 2000)

    }

    const HandleChangeRowsPerPage = (event) => {
        let value = event.target.value;
        console.log(event.target.value);
        setPerSet(value);
        setSetNo(1);
        setLeadObj((prev) => ({ ...prev, ['set_no']: 1 }));
        setLeadObj((prev) => ({ ...prev, ['per_set']: value }));
        setGetLeadList(true);

    };

    const ResetPagination = () => {
        setSetNo(1);
        setPerSet(10);
        setLeadObj((prev) => ({ ...prev, ['set_no']: 1 }));
        setLeadObj((prev) => ({ ...prev, ['per_set']: 10 }));
    }

    const NavigateTo = (route) => {
        navigate('/' + route, { state: {} });
    }

    const HandleInputs = (e, name) => {
        let value = '';

        if (name === 'txtCallBackDateTime') {
            value = e.$d;
            value = new Date(new Date(value).getTime() - (new Date(value).getTimezoneOffset() * 60000)).toISOString().substr(0, 19).replace('T', ' ')
        }
        else {
            value = e.target.value
        }

        if (name === 'txtLeadSearchName') {
            setLeadObj((prev) => ({ ...prev, ['txtLeadSearchName']: value }));
        }
        if (name === 'ddlCandidateStatus') {
            setLeadObj((prev) => ({ ...prev, ['ddlCandidateStatus']: value }));
            setGetLeadList(true);
        }
        if (name === 'ddlLeadStatus') {
            setInteractionData((prev) => ({ ...prev, ['ddlLeadStatus']: value }));
        }
        if (name === 'txtInteractionDesc') {
            setInteractionData((prev) => ({ ...prev, ['txtInteractionDesc']: value }));
        }
        if (name === 'txtCallBackDateTime') {
            setInteractionData((prev) => ({ ...prev, ['txtCallBackDateTime']: value }));
        }
        if (name === 'txtDeadReason') {
            setInteractionData((prev) => ({ ...prev, ['txtDeadReason']: value }));
        }
        if (name === 'ddlLeadDepartment') {
            setInteractionData((prev) => ({ ...prev, ['ddlLeadDepartment']: value }));
            setGetUserList(true);
        }
        if (name === 'ddlLeadOwner') {
            setInteractionData((prev) => ({ ...prev, ['ddlLeadOwner']: value }));
        }
    }

    const HandleGetUsersListSuccessResponse = (res) => {
        if (res != false && res != 'error') {
            console.log(res);
            let usersListData = res.data.userlistresponse.rows
            setUserListData(usersListData);
        }
        else {
            setUserListData([]);
        }
        setGetUserList(false);
    }

    const HandleGetLeadListSuccessResponse = (res) => {
        if (res != false && res != 'error') {
            console.log(res.data.leadlistresponse.rows[0])
            setLeadList(res.data.leadlistresponse.rows)
            setTotalRecords(res.data.leadlistresponse.metarow.totalRecordsInDb);
        }
        else {
            setLeadList([]);
            setTotalRecords(0);
        }
        setGetLeadList(false);
    }


    const ToggleFilter = () => {
        //  alert(openFilter);
        // userData.setState({ openFilter: true });
        if (openFilter === true) {
            setOpenFilter(false);
        }
        else {
            setOpenFilter(true);
        }
    }


    const SearchLeadList = (type, searchData) => {
        console.log(searchData);
        if (type === 'reload') {
            setLeadObj({
                'set_no': setNo,
                'per_set': perSet,
                'txtLeadSearchName': '',
                'ddlCandidateStatus': leadObj.ddlCandidateStatus
            })
        }
        else if (type === 'direct') {
            setLeadObj({
                'set_no': setNo,
                'per_set': perSet,
                'txtLeadSearchName': leadObj.txtLeadSearchName,
                'ddlCandidateStatus': leadObj.ddlCandidateStatus
            })
        }
        else {
            setLeadObj({
                'set_no': setNo,
                'per_set': perSet,
                'txtLeadSearchStartDate': searchData.txtLeadSearchStartDate,
                'txtLeadSearchEndDate': searchData.txtLeadSearchEndDate,
                'ddlLeadSearchState': searchData.ddlLeadSearchState,
                'ddlLeadSearchDistrict': searchData.ddlLeadSearchDistrict,
                'ddlLeadSearchDepartment': searchData.ddlLeadSearchDepartment,
                'ddlLeadSearchOwner': searchData.ddlLeadSearchOwner,
                'ddlLeadSearchProject': searchData.ddlLeadSearchProject,
                'ddlLeadSearchStatus': searchData.ddlLeadSearchStatus,
                'ddlCandidateStatus': leadObj.ddlCandidateStatus
            })

            ToggleFilter();
        }
        ResetPagination();
        setGetLeadList(true);

    }

    const ToggleInteractionBox = () => {
        if (openInteractionBox == true) {
            setOpenInteractionBox(false);
        }
        else {
            setOpenInteractionBox(true);
        }
    }

    const MakeNewCall = (leadData) => {

       // console.log(leadData);

        setCallObj({
            'txtUserNumber': leadData.user_mobile,
            'txtCallerNumber': userData,
            'txtUserName': leadData.user_name,
            'txtUserEmail': leadData.user_email,
            'txtLeadId': leadData._id,
            'txtLeadOwner': leadData.lead_owner,
            'txtLeadStatus': leadData.lead_status,
            'txtLeadSource': leadData.lead_source,
        });


        console.log(callObj);


        setMakeCall(true);
        // call exotel api to make call


      //  HandleMakeCallResponse(true);
    }

    const HandleMakeCallResponse = (res) => {
        setMakeCall(false);

        if (res !== false) {
            setShowAlert(true);
            setAlertType('success')
            setAlertMsg(res.data.exotelcallresponse.message.value);
            // now open interaction popup after 3 sec
            setTimeout(() => {
                ToggleInteractionBox();
            }, 3000)

        }
        else {
            setShowAlert(true);
            setAlertType('error')
            setAlertMsg('Call Failed');
        }

    }


    const AddNewInteraction = () => {
        if (interactionData.ddlLeadStatus == undefined || interactionData.ddlLeadStatus == null || interactionData.ddlLeadStatus.trim() == '') {
            setInteractionData((prev) => ({ ...prev, ['ddlLeadStatusErr']: 'Please Select Status' }));
            return false;
        }
        else {
            setInteractionData((prev) => ({ ...prev, ['ddlLeadStatusErr']: '' }));
        }
        if (interactionData.ddlLeadStatus === 'Call Back') {
            if (interactionData.txtCallBackDateTime == undefined || interactionData.txtCallBackDateTime == null || interactionData.txtCallBackDateTime.trim() == '') {
                setInteractionData((prev) => ({ ...prev, ['txtCallBackDateTimeErr']: 'Please Select Call Back Datetime' }));
                return false;
            }
            else {
                setInteractionData((prev) => ({ ...prev, ['txtCallBackDateTimeErr']: '' }));
            }
        }
        if (interactionData.ddlLeadStatus === 'Dead') {
            if (interactionData.txtDeadReason == undefined || interactionData.txtDeadReason == null || interactionData.txtDeadReason.trim() == '') {
                setInteractionData((prev) => ({ ...prev, ['txtDeadReasonErr']: 'Please Enter Dead Reason' }));
                return false;
            }
            else {
                setInteractionData((prev) => ({ ...prev, ['txtDeadReasonErr']: '' }));
            }
        }
        if (interactionData.ddlLeadStatus === 'In Progress') {
            if (interactionData.ddlLeadDepartment == undefined || interactionData.ddlLeadDepartment == null || interactionData.ddlLeadDepartment.trim() == '') {
                setInteractionData((prev) => ({ ...prev, ['ddlLeadDepartmentErr']: 'Please Select Department' }));
                return false;
            }
            else {
                setInteractionData((prev) => ({ ...prev, ['ddlLeadDepartmentErr']: '' }));
            }
            if (interactionData.ddlLeadOwner == undefined || interactionData.ddlLeadOwner == null || interactionData.ddlLeadOwner.trim() == '') {
                setInteractionData((prev) => ({ ...prev, ['ddlLeadOwnerErr']: 'Please Select Owner' }));
                return false;
            }
            else {
                setInteractionData((prev) => ({ ...prev, ['ddlLeadOwnerErr']: '' }));
            }
        }
        setInteractionData((prev) => ({ ...prev, ['txtLeadId']: callObj.txtLeadId }));
        console.log(interactionData);
        // console.log(callObj);
        // call interaction api

        setAddInteraction(true);
    }

   


    const HandleInteractionSuccessResponse = (res) => {
        console.log(res);

        if (res !== false) {
            setShowAlert(true);
            setAlertType('success')
            setAlertMsg(res.data.interactionresponse.message.value);
        }
        else {
            setShowAlert(true);
            setAlertType('error')
            setAlertMsg('Interaction Not Added');
        }
        setInteractionData({});
        ToggleInteractionBox();
        setGetLeadList(true);
        setAddInteraction(false);
    }






    return (
        <Box>
            {
                openFilter === true ?

                    <Filters ToggleFilter={ToggleFilter} candidateStatus={leadObj.ddlCandidateStatus} SearchList={SearchLeadList} />

                    :
                    null
            }
            <LeadsComp
                HandleChangePage={HandleChangePage} HandleChangeRowsPerPage={HandleChangeRowsPerPage}
                mystate={state}
                NavigateTo={NavigateTo}
                HandleInputs={HandleInputs}
                ToggleFilter={ToggleFilter}
                SearchLeadList={SearchLeadList}
                MakeNewCall={MakeNewCall}
                HandleCloseAlertMsg={HandleCloseAlertMsg}
                interactionData={interactionData}
                ToggleInteractionBox={ToggleInteractionBox}
                AddNewInteraction={AddNewInteraction}

            />
            {((getLeadList === true) ? GetAllLeads(pnkstore, leadObj, userData.getState().token, HandleGetLeadListSuccessResponse) : "")}
            {((getUserList === true) ? GetUserList(pnkstore, {}, userData.getState().token, HandleGetUsersListSuccessResponse) : "")}
            {((makeCall === true) ? MakeCall(pnkstore, callObj, userData.getState().token, HandleMakeCallResponse) : "")}
            {((addInteraction === true) ? AddInteraction(pnkstore, interactionData, userData.getState().token, HandleInteractionSuccessResponse) : "")}
        </Box>
    )
}